import React, { useEffect } from "react";
function ContactComponent() {
  return (
    <>
      <section>
        <h1>
          {" "}
          <span className="page-title border-small"></span>Contact Us
        </h1>
        <div className="content bg-blue">
          <div className="content-img">
            <img alt="contact" src={"assets/img/contact.jpg"} />
          </div>
          <div className="content-white">
            <ul>
              <li>+91-9820478909</li>
              <li>info@am-pmengineering.in</li>
              <li>
                ADDRESS<br/> 12, cama chambers, 23.Nagindas master road, Fort,
                Mumbai-400023. (INDIA) 
              </li>
            </ul>
          </div>
          <hr className="hr-color-white"/>
          <form>
            <div className="form-group">
              <label>Email address</label>
              <input
                type="email"
                className="form-control"
                aria-describedby="emailHelp"
              />
              <small>We'll never share your email with anyone else.</small>
            </div>
            <div className="form-group">
              <label>Contact No.</label>
              <input type="number" className="form-control" />
            </div>
            <div className="form-group">
              <label>Message</label>
              <textarea className="form-control"></textarea>
            </div>
            <button type="submit" className="btn btn-primary btn-yellow">
              Submit
            </button>
          </form>
        </div>
      </section>
    </>
  );
}

export default ContactComponent;
